<template>
  <div class="layout-container">
    <sidebar>
      <div class="sidebar-section-top">
        <img class="logo" :src="`/assets/logo-white.png`">
      </div>
      <div class="sidebar-section-bottom">
        <div class="user-box">
          <div class="user-box-worker">{{ fullName }}</div>
        </div>

        <div @click="logout" class="logout-button">{{ $t('Log out') }}</div>
      </div>
    </sidebar>

    <div class="content">
      <transition name="slide" mode="out-in" appear>
        <router-view>

        </router-view>
      </transition>
    </div>
  </div>
</template>

<script>

import Sidebar from '@/globals/components/Sidebar.vue';
import { getBasicAuthLogoutUrl } from '@/globals/helpers/basicAuthLookup';

export default {
  name: 'Layout-plain',
  components: {
    Sidebar,
  },
  computed: {
    fullName() {
      return this.$store.state.authentication.user.fullName
        ? this.$store.state.authentication.user.fullName
        : this.$store.state.authentication.user.username;
    },
  },
  methods: {
    async logout() {
      const basicAuthLogoutUrl = getBasicAuthLogoutUrl(
        this.$store.state.authentication.user?.email,
      );
      if (basicAuthLogoutUrl) {
        const logoutWindow = window.open(basicAuthLogoutUrl, 'Logout', 'menubar=0,resizable=1,width=10,height=10');
        await new Promise((resolve) => {
          setTimeout(() => {
            logoutWindow.close();
            resolve();
          }, 2000);
        });
      }

      this.$store.dispatch('authentication/logout');
    },
  },
};

</script>

<style scoped lang="scss">
  .layout-container {
    min-height: 100vh;
    width: 100%;
    display: flex;
  }

  .sidebar {

    .logo {
      font-size: 26px;
      margin-bottom: 50px;
      width: 80%;
    }

    .sidebar-section-bottom {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .user-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      align-self: stretch;
      margin-bottom: 60px;

      &-worker {
        font-weight: bold;
        font-size: 16px;
        padding-bottom: 8px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.3);
        width: 100%;
        text-align: center;
        margin-bottom: 10px;
      }

      &-name {
        font-size: 22px;
        margin-bottom: 4px;
      }

      &-profession {
        font-size: 16px;
      }
    }

    .logout-button {
      border: 1px solid #fff;
      border-radius: 8px;
      padding: 10px 42px;
      text-align: center;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }
  }

  .content {
    flex: 1;
    display: flex;
    max-height: 100vh;
    overflow: auto;
  }
</style>
